






















































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { ElForm } from 'element-ui/types/form';
import { getTenantData } from '@/serve/medicalAppointment/institutionManage';
import {
  getOrderLIst,
  getOneDetail,
} from '@/serve/professional/index';
interface Data {
  current?: number;
  size?: number;
  [propName: string]: any;
}
interface Detail {
  [propName: string]: any;
}
@Component({
  name: 'MedicalReport',
})
export default class MedicalReport extends Vue {
  public currentPage4 = 1;
  public form = {
    checkerName: '',
    current: 1,
    size: 10,
    // checkerIdCard: '',
    // checkStartTime: '',
    // checkEndTime: '',
    // tenantId: '',
  };
  public detailList = {
    jkglChecker: {},
  };
  public date = [];
  public tableData = [];
  public dialogFormVisible = false;
  public isAdmin = sessionStorage.getItem('isAdmin');
  public tenantName = '';
  public restaurants = [];
  public created() {
    this.getReportList();
  }
  public mounted() {
    this.getTenantData();
  }
  /**获取全部租户 */
  public async getTenantData(): Promise<void> {
    const res = await getTenantData({ size: 100000, current: 1 });
    this.restaurants = res.data.records;
  }
  public async querySearch(queryString: any, cb: any) {
    const restaurants = this.restaurants;
    const newArr: any = [];
    restaurants.forEach((x: any) => {
      if (x.name.includes(queryString)) {
        newArr.push({ value: x.name, tId: x.id });
      }
    });
    // 调用 callback 返回建议列表的数据
    cb(newArr);
  }
  // 获取数据接口
  public async getReportList() {
    // 如果form的数据有'' 则赋值为null 由于后端也会查询''类型的值
    for (const key in this.form) {
      if ((this.form as Data)[key] === '') {
        (this.form as Data)[key] = null;
      }
    }
    const res = await getOrderLIst(this.form);
    this.tableData = await res.data;
  }
  // 重置功能
  public resetForm(formName: string) {
    (this.$refs[formName] as ElForm).resetFields();
    this.currentPage4 = 1;
    this.date = [];
    this.getReportList();
  }
  // 筛选按钮
  public onSubmit() {
    // 点击筛选后 初始化值
    this.currentPage4 = 1;
    this.form.size = 10;
    this.form.current = 1;
    this.getReportList();
  }
  // 详情按钮点击
  public async readMore(id: number) {
    this.dialogFormVisible = true;
    const res = await getOneDetail(id);
    this.detailList = await res.data;
  }
  // 对时间格式进行切割
  public spliceTime(time: string): string | void {
    const arr = time ? time.split(' ') : '';
    return arr[0];
  }
  // 点击左右箭头
  public handleSizeChange(val: any): void {
    this.form.size = val;
    this.getReportList();
  }
  // 点击页码
  public handleCurrentChange(val: any): void {
    this.form.current = val;
    this.getReportList();
  }
}
